import { useStoreState } from 'easy-peasy';
import { SEARCHING_TASKS_VIEW_TYPES } from '@app/constants/searching';
import { AppTasksStack } from '@components/AppTasks/AppTasksStack';
import { AppTasksMasonry } from '@components/AppTasks/AppTasksMasonry';
import { jobStoreSelector } from '@model/Job/Job.selectors';
import { useActivitiesStacks } from '@components/AppTasks/_hooks/use-activities-stacks';

export const AppTasks = ({ currentView }) => {
  const job = useStoreState(jobStoreSelector);
  const { stacks, flattenedStacks } = useActivitiesStacks();

  if (currentView === SEARCHING_TASKS_VIEW_TYPES.LIST) {
    return <AppTasksStack stacks={stacks} />;
  }

  if (currentView === SEARCHING_TASKS_VIEW_TYPES.GRID) {
    return <AppTasksMasonry stacks={flattenedStacks} />;
  }

  return null;
};

const sortTasksByDate = (a, b) => (a.completedAt < b.completedAt ? 1 : -1);
